import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Tooltip, Row, Col } from 'antd'
import dayjs from 'dayjs'
import Suggested from 'model/appointments/timeSlots/suggested'
import Appointment from 'model/appointments/appointment'
import { Label } from 'pages/Ticket/styled'
import { disabledBeforeDate } from 'utils/helpers/dateHelper'
import { DatePicker, Button } from 'ui/styled'
import TimePicker from 'components/TimePicker'
import useAppointmentUpdate from 'apollo/mutations/APPOINTMENT_UPDATE'

const SuggestSlot = ({ appointment, locationUuid }) => {
  const [date, setDate] = useState()
  const [time, setTime] = useState()

  const { onAppointmentUpdate } = useAppointmentUpdate()

  const { hasCanceledSlot = false } = appointment

  const handleSubmit = () => {
    if (!date || !dayjs(time).isValid()) return false
    const suggestedSlot = new Suggested({
      kind: 'suggested',
      ...Appointment.getTimeSlotBoundaries(date, time)
    })

    return onAppointmentUpdate({
      id: appointment.id,
      attributes: {
        with: 'suggest',
        time_slots_attributes: [
          {
            ...suggestedSlot.toObject,
            kind: 'suggested'
          }
        ],
        location_uuid: locationUuid
      }
    })
  }

  const onChangeDate = v => {
    setDate(v)
    setTime()
  }

  const onChangeTime = v => {
    if (v) setTime(dayjs(v, 'hh:mm A'))
    else setTime()
  }

  const fieldResetKey = date ? date.format('MM-DD-YYYY') : 0

  return (
    <>
      <Label noMargin>Suggest date and time</Label>
      <Row gutter={16}>
        <Col span={8}>
          <DatePicker
            disabledDate={disabledBeforeDate}
            onChange={onChangeDate}
            format="MM-DD-YYYY"
            data-test="appointmentDatePicker"
          />
        </Col>
        <Col span={8}>
          <TimePicker
            key={fieldResetKey}
            onSelect={onChangeTime}
            startMoment={date}
            disabled={!date}
            allowClear={false}
            assumeMidnight
          />
        </Col>
        <Col span={8}>
          {hasCanceledSlot && (
            <Tooltip title="To suggest a new time, remove all canceled slots">
              <Button
                onClick={handleSubmit}
                data-test="ticketDisabledSendDateBtn"
                disabled
              >
                Send
              </Button>
            </Tooltip>
          )}
          {!hasCanceledSlot && (
            <Button
              data-test="ticketSendDateBtn"
              onClick={handleSubmit}
              disabled={!date || !time}
            >
              Send
            </Button>
          )}
        </Col>
      </Row>
    </>
  )
}

SuggestSlot.propTypes = {
  appointment: PropTypes.shape(Appointment.shape).isRequired,
  locationUuid: PropTypes.string.isRequired
}

export default SuggestSlot
